<p class="c-texts--attention h-margin--b16">＊は入力必須項目です</p>
<app-input-table
  [formItems]="formItems"
  [formValue]="formValue"
  (changeEvent)="updateValue($event)"
  (keyUpEvent)="updateValue($event)"
>
  <ng-content></ng-content>
</app-input-table>
